import React from 'react';

import { Plus } from 'lucide-react';

interface AddNewButtonProps {
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  label?: string;
}

const AddNewButton: React.FC<AddNewButtonProps> = ({
  onClick,
  variant = 'primary',
  label = 'Add New',
}) => {
  const baseClasses =
    'inline-flex items-center justify-center h-10 gap-2 px-6 text-sm font-semibold tracking-wide transition duration-300 rounded-md whitespace-nowrap cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 dark:focus-visible:ring-offset-secondary disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-200 disabled:text-ink-muted disabled:shadow-none';

  // Matches Button.tsx. Text on gold is black (9.05:1), never white (2.32:1), and gold keeps its
  // brand colours in dark mode instead of falling back to grey.
  const variantClasses = {
    primary: 'bg-primary text-secondary hover:bg-opacity-90',
    secondary:
      'border border-secondary text-ink bg-white hover:bg-secondary hover:text-white dark:border-white/30 dark:bg-transparent dark:text-white dark:hover:bg-white dark:hover:text-secondary',
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]}`}
    >
      <span className="order-2">{label}</span>
      <span className="relative">
        <Plus
          className="w-5 h-5"
          aria-hidden="true"
          role="graphics-symbol"
          aria-label="Add Icon"
        />
      </span>
    </button>
  );
};

export default AddNewButton;
